import { Link } from "react-router-dom";
import type { Movie } from "@/lib/media";
import { mediaTypeLabel } from "@/lib/media";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link to={`/detail/${movie.id}`} className="group block cursor-pointer">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}海报`}
          title={`${movie.title} 影视推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/5 to-transparent" />
        <span className="absolute right-2 top-2 rounded-md bg-background-50/95 px-1.5 py-0.5 font-heading text-xs font-semibold text-primary-700">
          {movie.score.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/55 px-1.5 py-0.5 text-[10px] font-medium text-background-50 backdrop-blur-sm">
          {mediaTypeLabel[movie.type]}
        </span>
        <span className="absolute bottom-2 left-2 rounded-md bg-background-50/90 px-1.5 py-0.5 text-[10px] text-foreground-700">
          {movie.year}
        </span>
        <span className="absolute bottom-2 right-2 flex h-7 w-7 translate-y-1 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <i className="ri-arrow-right-up-line text-sm" />
        </span>
      </div>
      <div className="mt-3">
        <h3 className="truncate font-heading text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.duration}
        </p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800"
            >
              {genre}
            </span>
          ))}
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
      </div>
    </Link>
  );
}